import gql from 'graphql-tag';

export const GET_GOLFGROUP = gql`
    query {
        golfGroup{
            golf_group_code
            golf_group_name
            point_use_type
        }
    } 
`;
export const GET_GOLFCOURSE = gql`
    query ( $golf_group_code: String! ) {
        getGolfCourse (golf_group_code: $golf_group_code) {
            golf_code
            golf_name
        }
    } 
`;
export const GET_POINT_LIST = gql`
    query (
        $member_no: ID!,
        $golf_group_code: String!,
        $golf_code: String,
        $point_type: Int,
        $begin_row: Int,
        $golf_name: String,
        $limit_rows: Int,
        $display_flag: Int
    ) {
        getPointList(
            member_no: $member_no,
            golf_group_code: $golf_group_code,
            golf_code: $golf_code,
            point_type: $point_type,
            begin_row: $begin_row,
            golf_name: $golf_name,
            limit_rows: $limit_rows,
            display_flag: $display_flag
            )
        {
            PointList {
                id
                processing_date
                point_type
                action
                point
                golf_code
                comment
                valid_start
                valid_date
                golf_name
                point_flag
                point_type_display
                member_rank
            }
            count
        }
    },
`;
export const GET_POINT_TOTAL = gql`
    query ($member_no: ID!, $golf_group_code: String!, $golf_code: String) {
        getPointTotal(member_no: $member_no, golf_group_code: $golf_group_code, golf_code: $golf_code) {
            total_point
        }
    },
`;

export const GET_POINT_TOTAL_FROM_MEMBER_POINT_HISTORY = gql`
    query ($member_no: ID!, $golf_group_code: String!, $golf_code: String, $target_date: String) {
        getPointTotalFromMemberPointHistory(member_no: $member_no, golf_group_code: $golf_group_code, golf_code: $golf_code, target_date: $target_date){
            total_point{
                total_all
                total_expected
            }
        }
    }
`;
